import apiClient from './apiClient';

export interface RomanianDataStats {
  addresses: {
    total: number;
    judete: number;
    localitati: number;
    cu_coordonate: number;
  };
  companies: {
    total: number;
    active: number;
    judete: number;
    orase: number;
    caen_codes: number;
  };
  summary: {
    total_addresses: number;
    total_companies: number;
    last_updated: string;
  };
}

export interface ImportResult {
  success: boolean;
  count: number;
  errors: string[];
  type: string;
}

export interface CleanupResult {
  success: boolean;
  data: {
    deleted: number;
  };
  message: string;
}

export interface ExportResult {
  success: boolean;
  data: any[];
  count: number;
  type: string;
}

class AdminService {
  /**
   * Obtine statistici complete despre datele din Romania
   */
  async getRomanianDataStats(): Promise<RomanianDataStats> {
    try {
      const response = await apiClient.get('/admin/romanian-data/stats');
      return response.data.data;
    } catch (error) {
      throw error;
    }
  }

  /**
   * Importa date din Excel (ADMIN ONLY)
   */
  async importRomanianData(type: 'addresses' | 'companies', filePath: string): Promise<ImportResult> {
    try {
      const response = await apiClient.post('/admin/romanian-data/import', {
        type,
        filePath
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  /**
   * Curata datele duplicate (ADMIN ONLY)
   */
  async cleanupRomanianData(type: 'addresses' | 'companies'): Promise<CleanupResult> {
    try {
      const response = await apiClient.post('/admin/romanian-data/cleanup', {
        type
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  /**
   * Exporta date in Excel (ADMIN ONLY)
   */
  async exportRomanianData(type: 'addresses' | 'companies', filters: any = {}): Promise<ExportResult> {
    try {
      const response = await apiClient.post('/admin/romanian-data/export', {
        type,
        filters
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  /**
   * Obtine log-urile de eroare (ADMIN ONLY)
   */
  async getErrorLogs(): Promise<{ errors: string[]; logFile: string; totalLines: number }> {
    try {
      const response = await apiClient.get('/admin/errors');
      return response.data;
    } catch (error) {
      throw error;
    }
  }
}

export const adminService = new AdminService();
export default adminService; 
